import { Arrangement } from 'types/arrangement';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import { Fragment } from 'react';
import { Precedent } from 'types/precedent';
import { Spin } from 'antd';
import { interpolate } from 'utils/interpolate';
import useTranslation from 'hooks/use-translation';

type Props =
  | { arrangement: Arrangement; creditType: CreditType.ARTICULATION }
  | { precedent: Precedent; creditType: CreditType.PRECEDENT };

export default function SubjectsSection(props: Props): JSX.Element {
  const { creditType } = props;
  const translation = useTranslation();

  const subjects = creditType === CreditType.ARTICULATION ? props.arrangement.subjects : props.precedent.subjects;

  if (!translation) {
    return <Spin />;
  }

  return (
    <FlexContainer gap={12} flexDirection='column' alignItems='start' alignSelf='start' style={{ marginTop: 0 }}>
      {subjects.map((subject) => {
        const subjectText = subject.unspecified
          ? subject.name
          : interpolate(translation.subjectFormat, { name: subject.name, code: subject.code });
        return (
          <Fragment key={subject.ID}>
            <span>{subjectText}</span>
          </Fragment>
        );
      })}
    </FlexContainer>
  );
}
